import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  card: theme => ({
    paddingVertical: 12,
    paddingHorizontal: 16,
    flex: 1,
    marginTop: 16,
    borderRadius: 5,
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  groupStep: {
    paddingVertical: 32
  },

  divider: {
    marginVertical: 32,
    borderBottomWidth: 1,
    borderBottomColor: '#EBEBEB'
  },
  marginBottom: {
    marginBottom: 16
  },
  explain: {
    lineHeight: 18
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    paddingBottom: 16
  },
  description: {
    fontSize: 16,
    lineHeight: 18,
    letterSpacing: 0.1
  },
  subtitle: {
    fontSize: 18,
    fontWeight: 'bold',
    paddingVertical: 12
  },
  verticalSpacer: {
    paddingTop: 16,
    paddingBottom: 32
  },
  nameForm: {
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#EBEBEB'
  },
  members: {
    paddingBottom: 32
  },
  smsHint: {
    fontSize: 14,
    lineHeight: 18,
    letterSpacing: 0.1
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  content: {
    paddingTop: 16
  }
})

export default styles
